/*
  DogPure · carrusel horizontal sin dependencias.
  Estructura: <dp-carousel> con [data-track] (lista desplazable), [data-prev], [data-next] y [data-progress].
  Sin reproducción automática ni bucle. Si todo el contenido cabe, marca [data-static] y el CSS oculta los controles.
*/
if (!customElements.get('dp-carousel')) {
  class DpCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.progress = this.querySelector('[data-progress]');
      if (!this.track) return;
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      new ResizeObserver(this.update).observe(this.track);
      this.update();
    }

    go(direction) {
      const item = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * step, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const max = Math.max(scrollWidth - clientWidth, 0);
      const isStatic = max <= 2;
      this.toggleAttribute('data-static', isStatic);
      this.track.toggleAttribute('tabindex', !isStatic);
      if (!isStatic) this.track.setAttribute('tabindex', '0');
      if (this.progress) {
        const visible = Math.min(clientWidth / scrollWidth, 1);
        const ratio = max ? scrollLeft / max : 0;
        this.progress.style.setProperty('--dp-thumb', `${visible * 100}%`);
        this.progress.style.setProperty('--dp-offset', `${ratio * (1 / visible - 1) * 100}%`);
      }
      if (this.prev) this.prev.disabled = scrollLeft <= 2;
      if (this.next) this.next.disabled = scrollLeft >= max - 2;
      this.toggleAttribute('data-at-end', scrollLeft >= max - 2);
    }
  }
  customElements.define('dp-carousel', DpCarousel);
}
